import { RuleObject } from "antd/es/form";

export const validatePasswordValue = (password: string) => {
  const hasNumber = /[0-9]/.test(password);
  const hasLowercase = /[a-zа-я]/.test(password);
  const hasUppercase = /[A-ZА-Я]/.test(password);
  const isLongEnough = password.length >= 8;

  if (!hasNumber) {
    return {
      success: false,
      errorMessage: "Пароль должен содержать хотя бы одну цифру.",
    };
  }

  if (!hasLowercase) {
    return {
      success: false,
      errorMessage: "Пароль должен содержать хотя бы одну строчную букву.",
    };
  }

  if (!hasUppercase) {
    return {
      success: false,
      errorMessage: "Пароль должен содержать хотя бы одну заглавную букву.",
    };
  }

  if (!isLongEnough) {
    return {
      success: false,
      errorMessage: "Пароль должен содержать не менее 8 символов.",
    };
  }

  return { success: true, errorMessage: null };
};

export const formPasswordValidator = (rule: RuleObject, value: string) => {
  const { errorMessage } = validatePasswordValue(value);

  if (errorMessage) {
    return Promise.reject(errorMessage);
  }

  return Promise.resolve();
};
